
export interface IUserGameOrientationService {
  readonly  gameGroup: IUserGameOrientation;
}

export enum GAME_ORIENTATION_IDS{
  SLOTS = 5003,
  BLACKJACK = 5001,
  ROULETTE = 5002,
  LIVE_BLACKJACK = 5009,
  LIVE_ROULETTE = 5010,
  LIVE_CASINO = 6003,
  CASINO_SKILL = 6001,
  CASINO_SOFT = 6002,
  CASINO_MIXT = 8001
}

export interface IUserGameOrientation{
  groupId?: number;
  groupName: string;
}